// Module-level ref updated via setAnalyticsContext. This is a plain module value
// (not React state) because the wrapper is called from non-hook code; the current
// org/user/plan is pushed in from the provider effect via setAnalyticsContext.
let analyticsContext = {};
// Update the shared analytics properties merged into every event and page. Call
// this from the org/auth provider effect whenever organization, user, or plan
// changes so the wrapper always reads current values.
export function setAnalyticsContext(context) {
    analyticsContext = Object.assign({}, context);
}
function getAnalytics() {
    if (typeof window === 'undefined')
        return undefined;
    const globalWithAnalytics = window;
    return globalWithAnalytics.analytics;
}
// Merge the shared context first so explicit call-site properties win on collision.
// Undefined entries are dropped so we never send empty properties to Segment; every
// key on AnalyticsContext is attached automatically.
function withSharedProperties(properties) {
    const shared = {};
    for (const [key, value] of Object.entries(analyticsContext)) {
        if (value !== undefined)
            shared[key] = value;
    }
    return Object.assign(Object.assign({}, shared), properties);
}
// Track a Segment event. Use a name from eventTypes (see ./constants).
export function track(event, properties) {
    const analytics = getAnalytics();
    if (!analytics)
        return;
    analytics.track(event, withSharedProperties(properties));
}
// Track a Segment page view. Use a name from pageTypes (see ./constants).
export function trackPage(page, properties) {
    const analytics = getAnalytics();
    if (!analytics)
        return;
    analytics.page(page, withSharedProperties(properties));
}
//# sourceMappingURL=analytics.js.map